import { get } from "lodash";

export default{
    namespaced:true,
    state:{
        discount:{}
    },
    mutations:{
        ADD_DISCOUNT(state,discount){
            state.discount = discount
        },
        REMOVE_DISCOUNT(state){
            state.discount = {}
        }
    },
    getters:{
        discount: state=> state.discount,

        discountEmail(state, getters, rootState, rootGetters){
            let email = '';
            if(rootGetters["customer/isAuth"]){
                email = rootGetters["customer/getCustomer"].email
            }else{
                if(rootGetters['hasOnlyDigitalItems']){
                    email = get(rootGetters['checkout/digitalInfo'],'email')
                }else{
                    email = get(rootGetters['checkout/_shippingInfo'],'email')
                }
            }

            return email
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/store/discount.js